export const FORM_TREE_VIEW = 'FORM_TREE_VIEW';
export const DOCUMENT_TREE_VIEW = 'DOCUMENT_TREE_VIEW';
export const REBUILD_LOGS = 'REBUILD_LOGS';
export const TRAINING_LOGS = 'TRAINING_LOGS';
export const FORM_EDIT = 'FORM_EDIT';
export const FORM_TYPE_EDIT = 'FORM_TYPE_EDIT';
export const FORM_TYPE_VERSION_EDIT = 'FORM_TYPE_VERSION_EDIT';
export const FORM_TYPE_VERSION_PAGE_EDIT = 'FORM_TYPE_VERSION_PAGE_EDIT';
